export enum TenancyTypes {
  single = 'Single',
  multi = 'Multi',
}

export const TenancyTypeNames: { [key: string]: string } = {
  1: TenancyTypes.single,
  2: TenancyTypes.multi,
};
